import type { VariantProps } from "class-variance-authority";
import type { ComponentProps } from "react";

import { Slot } from "@radix-ui/react-slot";
import { LoaderCircle } from "lucide-react";

import { cn } from "@/lib/utils";

import { buttonVariants } from "./button.styles";

export type ButtonProps = {
  asChild?: boolean;
  loading?: boolean;
} & ComponentProps<"button"> &
VariantProps<typeof buttonVariants>;

export function Button({ ref, className, variant, size, asChild = false, children, loading, ...props }: ButtonProps) {
  const Comp = asChild ? Slot : "button";

  return (
    <Comp
      className={cn(buttonVariants({ variant, size, className, loading }))}
      ref={ref}
      {...props}
    >

      {loading
        ? <LoaderCircle className="animate-spin" />
        : children}
    </Comp>
  );
};
